import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import { PortfolioCovenantsContainerV2 } from 'packages/borrowing-base/ui/PortfolioCovenantsContainerV2';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import CapitalProviderContextProvider from 'packages/organization/hooks/CapitalProviderContextProvider';

export const InsightsPortfolioCovenantsRoute = withLDConsumer()(({ flags }) => {
  const toast = useToast();
  const history = useHistory();
  const { data: userData } = useGetUserQuery();

  if (!userData || !userData.user) {
    return (
      <Skeleton
        height="600px"
        data-testid="insights-portfolio-covenants-loading"
      />
    );
  }

  if (!flags?.displayPortfolioCovenants) {
    return <Redirect to="/" />;
  }

  let routeLevelError = false;

  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights portfolio covenants page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <InsightsTemplate
          selectedTab={TAB_OPTION_KEYS.portfolioCovenants}
          organizationId={userData?.user?.organizationId}
        >
          <CapitalProviderContextProvider renderLoading={<Skeleton />}>
            <PortfolioCovenantsContainerV2 />
          </CapitalProviderContextProvider>
        </InsightsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
});
